<template>
    <client-page>
        <template v-slot:subHead>
            <sub-visual sh="Facilities" tabActive="Meitex_China" bg="/images/sub/visual/sv-facilities.jpg" />
        </template>

        <sub-section class="page-section--first">
            <div class="tit-wrap text-center">
                <h3 class="tit tit--lg">Meitex_China</h3>
            </div>

            <v-row align="center" justify="space-between" class="row--small">
                <v-col cols="12" sm="auto">
                    <h3 class="tit tit--symbol" data-aos="fade-right">니팅 및 제직 공장</h3>
                </v-col>
                <v-col cols="12" sm="auto">
                    <p class="page-text grey-a--text text-right">Meitex_China</p>
                </v-col>
            </v-row>
            <v-divider class="border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40" />

            <v-row>
                <v-col cols="12" md="4">
                    <v-row>
                        <v-col cols="6" md="12">
                            <v-img height="100%" class="ma-auto" src="/images/sub/facilities/facilities-img.jpg" />
                        </v-col>
                        <v-col cols="6" md="12">
                            <v-img height="100%" class="ma-auto d-none d-md-block" src="/images/sub/facilities/facilities-img6.jpg" />
                            <v-row class="d-md-none">
                                <v-col cols="12">
                                    <v-img class="ma-auto" src="/images/sub/facilities/facilities-img2.jpg" />
                                </v-col>
                                <v-col cols="12">
                                    <v-img class="ma-auto" src="/images/sub/facilities/facilities-img3.jpg" />
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" md="8">
                    <v-row>
                        <v-col cols="6" class="d-none d-md-block">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img2.jpg" />
                        </v-col>
                        <v-col cols="6" class="d-none d-md-block">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img3.jpg" />
                        </v-col>
                        <v-col cols="6">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img4.jpg" />
                        </v-col>
                        <v-col cols="6">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img5.jpg" />
                        </v-col>
                        <v-col cols="6">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img7.jpg" />
                        </v-col>
                        <v-col cols="6">
                            <v-img class="ma-auto" src="/images/sub/facilities/facilities-img8.jpg" />
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </sub-section>

        <sub-section class="page-section--last">
            <v-row align="center" justify="space-between" class="row--small">
                <v-col cols="12" sm="auto">
                    <h3 class="tit tit--symbol" data-aos="fade-right">R&D 룸_ 쇼룸</h3>
                </v-col>
                <v-col cols="12" sm="auto">
                    <p class="page-text grey-a--text text-right">Meitex_China</p>
                </v-col>
            </v-row>
            <v-divider class="border-2 grey-2 mt-14 mb-24 mt-md-20 mb-md-40" />

            <v-row>
                <v-col cols="6" md="4">
                    <v-img class="ma-auto" src="/images/sub/facilities/facilities-img9.jpg" />
                </v-col>
                <v-col cols="6" md="4">
                    <v-img class="ma-auto" src="/images/sub/facilities/facilities-img10.jpg" />
                </v-col>
                <v-col cols="6" md="4">
                    <v-img class="ma-auto" src="/images/sub/facilities/facilities-img11.jpg" />
                </v-col>
            </v-row>
        </sub-section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import SubSection from "@/components/client/sub/sub-section.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        SubSection,
    },
};
</script>

<style lang="scss" scoped></style>
